import type { Report } from '../../types';
import { planeModulBuchung, type ModulBuchung } from '../bestandteile/modulBuchung';

/**
 * Die Leistungsbuchung des A+S-Plans nach der Freigabe (Plan Paketposition
 * B5, Betreiber 19.10.2026: „Buchung direkt nach der Erstellung anbieten").
 *
 * Bis hierhin buchte der A+S-Plan nichts — er „zaehlte nur". Jetzt bietet der
 * Abschlussschritt nach `freigeben` die Positionsauswahl an (BillingModule
 * 'asplan': nur Positionen mit der Zuordnung `asplan`, kein Textarm). Die
 * A+S-Kachel im Projekt-Hub zaehlt `quantityUsed` dieser Positionen und NICHT
 * die Freigaben — die Buchung hier ist also das, was sie zaehlt, nichts wird
 * doppelt gezaehlt (siehe ProjectModuleGrid).
 *
 * Rein. Journalquelle 'asplan' (Muster B: `onUpdate`, dann
 * `queueJournalMirror` mit der Vormerkung).
 */

/** Der Protokolltext — nennt die freigegebene Fassung, damit die Buchung ihr zuordenbar bleibt. */
export const asplanBuchungsText = (revLabel: string | null | undefined, menge: number, einheit: string): string => {
    const fassung = (revLabel || '').trim();
    return `A+S-Plan freigegeben (${fassung ? `Fassung ${fassung}` : 'ohne Fassungsbezeichnung'}) (${menge} ${einheit})`;
};

export const planeAsplanBuchung = (a: {
    report: Report;
    serviceId: string;
    hours: number;
    revLabel?: string | null;
    performerName: string;
    jetzt?: Date;
    neueId?: () => string;
}): ModulBuchung | null => planeModulBuchung({
    report: a.report,
    serviceId: a.serviceId,
    hours: a.hours,
    beschreibung: (menge, einheit) => asplanBuchungsText(a.revLabel, menge, einheit),
    performerName: a.performerName,
    source: 'asplan',
    jetzt: a.jetzt,
    neueId: a.neueId,
});
